import { render, staticRenderFns } from "./saveForm.vue?vue&type=template&id=4610f81c&"
import script from "./saveForm.vue?vue&type=script&lang=js&"
export * from "./saveForm.vue?vue&type=script&lang=js&"
import style0 from "./saveForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports